import { render, staticRenderFns } from "./ReservationFileDetails.vue?vue&type=template&id=696a6ad2&scoped=true&"
import script from "./ReservationFileDetails.vue?vue&type=script&lang=js&"
export * from "./ReservationFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFileDetails.vue?vue&type=style&index=0&id=696a6ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a6ad2",
  null
  
)

export default component.exports